import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Q_WPAI, WpaiResults} from '../../../../model/questionnaires/questionnaire-wpai';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {MatOptionSelectionChange} from '@angular/material/core';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-questionnaire-wpai',
  templateUrl: './questionnaire-wpai.component.html',
  styleUrls: ['./questionnaire-wpai.component.css']
})
export class QuestionnaireWpaiComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_WPAI;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  values: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
  results = [];
  answers: string[] = ['SI', 'NO'];
  isDisabled: boolean;
  isDisabled5 = false;
  q = 'question';
  found = false;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'WPAI';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;

  constructor(private questionnaireService: QuestionnaireService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.qForm = new FormGroup({
      question2: new FormControl({value: ''}, [Validators.required, Validators.min(0)]),
      question3: new FormControl({value: ''}, [Validators.required, Validators.min(0)]),
      question4: new FormControl({value: ''}, [Validators.required, Validators.min(0)])
    });
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  selectResult($event: MatOptionSelectionChange, value: string, position: number) {
    if ($event.isUserInput) {
      this.results[position - 1] = value;
      console.log(this.results);
      this.isDisabled = this.results[0] === 'NO';
      console.log(this.isDisabled);

      if (this.results[0] === 'NO') {
        this.qForm.get('question2').reset();
        this.qForm.get('question2').disable();
        this.qForm.get('question3').reset();
        this.qForm.get('question3').disable();
        this.qForm.get('question4').reset();
        this.qForm.get('question4').disable();
        this.qForm.get('question5').reset();
        this.qForm.get('question5').disable();

        for (let i = 1; i < 5; ++i) {
          this.results[i] = null;
        }
        console.log(this.results);

      } else {
        this.qForm.get('question2').enable();
        this.qForm.get('question3').enable();
        this.qForm.get('question4').enable();
        this.qForm.get('question5').enable();

        console.log(this.results);
      }
    }

  }

  setDisabled5(position: number) {
    if (this.qForm.get('question4').value === 0) {
     this.isDisabled5 = true;
     this.setResult(position);
    } else {
      this.isDisabled5 = false;
      this.setResult(position);
    }
  }

  setResult(position: number) {
    const question = 'question' + position;
    this.results[position - 1] = this.qForm.get(question).value.toString();
    console.log(question);
    console.log(this.qForm.get(question).value.toString());
    console.log(this.results);

    if (position === 4) {
      if (this.qForm.get(question).value === 0) {
        this.results[position] = null;
      }
    }
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;
    let questionnaireComplete = true;
    console.log(this.results);
    //CASO IN CUI SELEZIONO NO ALLA 1
    if(this.results[0] === 'NO' && this.results[5]!==null) {
        const resultToSend = new WpaiResults(this.doctorID, this.patientSSN, this.results);
        this.questionnaireService.sendForm(resultToSend, 'wpai', this.uuid);
      
    } else {

    for (let i = 0; i < this.results.length; ++i){
      if (i !== 4 && this.results[i] === null) {
        questionnaireComplete = false;
        this.show = false;
        this.submitted = false;
        this.found = true;
        const msg = 'Non hai finito di completare il questionario!';
        this.openDialog(msg);
        break;
      }
    }

    /*if (this.results.length !== this.dataSource.length) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openDialog(msg);
    } else {*/
    if(questionnaireComplete === true){
      let count = 0;
      if (this.results[0] === 'NO') {
        for (const r of this.results) {
          if (r === null) {
            count++;
            console.log('CAU');
          }
        }
        if (count !== 4) {
          this.show = false;
          this.submitted = false;
          this.found = true;
        }
      } else {

        if (this.results[3] === '0' ) {
          if (this.results[4] !== null) {
            this.show = false;
            this.submitted = false;
            this.found = true;
          }
        } else {
          for (const r of this.results) {
            if (r === null) {
              this.show = false;
              this.submitted = false;
              this.found = true;
            }
          }
        }
      }

      
      if (!this.found) {
          const resultToSend = new WpaiResults(this.doctorID, this.patientSSN, this.results);
          this.questionnaireService.sendForm(resultToSend, 'wpai', this.uuid);
        }
      } }

    console.log(this.found);

  }

  openDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }
}

